import { Button } from "react-admin";

import { Icon } from "../icons";

type CloseButtonProps = {
  onClick: () => void;
  "data-testid"?: string;
};

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick, "data-testid": dataTestId = "cancel-button" }) => (
  <Button label={"ra.action.cancel"} color="secondary" onClick={onClick} data-testid={dataTestId}>
    <Icon type="close" size="medium" />
  </Button>
);
